var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCauldron = function SvgCauldron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.664 9.88a9.1 9.1 0 0 0-.831 3.8c0 5.285 4.549 9.57 10.161 9.57s10.161-4.285 10.161-9.57a9.1 9.1 0 0 0-.832-3.8M3.553 1.487 6.9 8.74m10.175-3.635a1.452 1.452 0 1 0 0-2.904 1.452 1.452 0 0 0 0 2.904m-8.686-.522a31 31 0 0 1 4.331-.192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.7 5.83c1.367.607 2.177 1.361 2.177 2.178 0 2-4.874 3.629-10.887 3.629S1.107 10.012 1.107 8.008c0-.695.586-1.345 1.6-1.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.869 7.351a33 33 0 0 1 2.125-.069 27.8 27.8 0 0 1 6.367.685"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.454 2.201a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75m13.048.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgCauldron;